<template>
  <section class="create-service">
    <p-edit @submit="create" />
  </section>
</template>

<script>
import { mapState } from 'vuex';
import EditForm from './_CreateOrEditStt';

export default {
  components: {
    'p-edit': EditForm
  },
  data() {
    return {};
  },
  computed: {
    ...mapState({})
  },
  methods: {
    async create(sttService) {
      try {
        const newService = await this.$store.dispatch('nlp/createSttService', sttService);
        this.$router.push({ path: `/administration` });

        this.$toast.success({
          title: 'Created',
          message: `Speech to text service '${newService.name}' successfully created`
        });
      } catch (error) {
        const { message } = JSON.parse(await error.response.text());
        this.$toast.error({
          title: 'Failed to create speech to text service',
          message: message
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.create-service {
  display: grid;
  grid-gap: 0.5rem;
  grid-template-rows: minmax(0, 1fr);
  grid-template-columns: minmax(0, 2fr) minmax(0, 1fr);
  width: 100%;
  height: 100%;
  padding: 0 0.5rem 0 1rem;
}
</style>
